import { request } from './client'

/**
 * Uploading a photo or document: request a presigned URL, then put the bytes
 * there directly. The bytes never go through {@link request} — a presigned
 * URL is a signature over exactly the headers it was signed with, and this
 * API's bearer token and cookies have no place in that request.
 */
export type MediaCategory =
  'AVATAR' | 'KYC_DOCUMENT' | 'DELIVERY_PROOF' | 'AD_CREATIVE' | 'CONTACT_ATTACHMENT'

type UploadResponse = { key: string; uploadUrl: string; expiresAt: string }
type DownloadResponse = { downloadUrl: string; expiresAt: string }

/** Uploads `file` and returns the key to attach to whatever record it belongs to. */
export async function uploadMedia(category: MediaCategory, file: File): Promise<string> {
  const { key, uploadUrl } = await request<UploadResponse>('/media/uploads', {
    method: 'POST',
    body: { category, contentType: file.type },
  })

  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })
  if (!res.ok) {
    throw new Error("Échec de l'envoi du fichier.")
  }
  return key
}

/** A one-time URL to view a private object — the bucket has no public objects. */
export async function mediaDownloadUrl(key: string): Promise<string> {
  const { downloadUrl } = await request<DownloadResponse>(
    `/media/download-url?key=${encodeURIComponent(key)}`,
  )
  return downloadUrl
}
